import { Res } from 'core/api';

export function getName(code: string): string {
	const getNameFn = codeToGetName[code];
	return getNameFn ? getNameFn() : code;

}

const codeToGetName: Record<string, () => string> = {
	'an': Res.Const.LANGUAGE_AN,
	'be': Res.Const.LANGUAGE_BE,
	'bg': Res.Const.LANGUAGE_BG,
	'br': Res.Const.LANGUAGE_BR,
	'bs': Res.Const.LANGUAGE_BS,
	'ca': Res.Const.LANGUAGE_CA,
	'ce': Res.Const.LANGUAGE_CE,
	'co': Res.Const.LANGUAGE_CO,
	'cs': Res.Const.LANGUAGE_CS,
	'cy': Res.Const.LANGUAGE_CY,
	'da': Res.Const.LANGUAGE_DA,
	'de': Res.Const.LANGUAGE_DE,
	'dv': Res.Const.LANGUAGE_DV,
	'el': Res.Const.LANGUAGE_EL,
	'en': Res.Const.LANGUAGE_EN,
	'eo': Res.Const.LANGUAGE_EO,
	'es': Res.Const.LANGUAGE_ES,
	'et': Res.Const.LANGUAGE_ET,
	'eu': Res.Const.LANGUAGE_EU,
	'fa': Res.Const.LANGUAGE_FA,
	'fi': Res.Const.LANGUAGE_FI,
	'fo': Res.Const.LANGUAGE_FO,
	'fr': Res.Const.LANGUAGE_FR,
	'ga': Res.Const.LANGUAGE_GA,
	'gd': Res.Const.LANGUAGE_GD,
	'gl': Res.Const.LANGUAGE_GL,
	'hr': Res.Const.LANGUAGE_HR,
	'ht': Res.Const.LANGUAGE_HT,
	'hu': Res.Const.LANGUAGE_HU,
	'hy': Res.Const.LANGUAGE_HY,
	'is': Res.Const.LANGUAGE_IS,
	'it': Res.Const.LANGUAGE_IT,
	'ka': Res.Const.LANGUAGE_KA,
	'kk': Res.Const.LANGUAGE_KK,
	'kl': Res.Const.LANGUAGE_KL,
	'la': Res.Const.LANGUAGE_LA,
	'lb': Res.Const.LANGUAGE_LB,
	'lt': Res.Const.LANGUAGE_LT,
	'lv': Res.Const.LANGUAGE_LV,
	'mk': Res.Const.LANGUAGE_MK,
	'mt': Res.Const.LANGUAGE_MT,
	'nl': Res.Const.LANGUAGE_NL,
	'no': Res.Const.LANGUAGE_NO,
	'pl': Res.Const.LANGUAGE_PL,
	'pt': Res.Const.LANGUAGE_PT,
	'ro': Res.Const.LANGUAGE_RO,
	'ru': Res.Const.LANGUAGE_RU,
	'sc': Res.Const.LANGUAGE_SC,
	'sh': Res.Const.LANGUAGE_SH,
	'sk': Res.Const.LANGUAGE_SK,
	'sl': Res.Const.LANGUAGE_SL,
	'sq': Res.Const.LANGUAGE_SQ,
	'sr': Res.Const.LANGUAGE_SR,
	'sv': Res.Const.LANGUAGE_SV,
	'tr': Res.Const.LANGUAGE_TR,
	'uk': Res.Const.LANGUAGE_UK,
	'uz': Res.Const.LANGUAGE_UZ,
	'vi': Res.Const.LANGUAGE_VI,
	'zh': Res.Const.LANGUAGE_ZH
};